<div class="container">
  <h1 class="h1">Résultats de la recherche</h1>
  <ng-container *ngIf="products$ | async as products">
    <ng-container *ngIf="products.length > 0; else notFound">
      <div fxLayout="row wrap" fxLayoutGap="16px grid">
        <div
          *ngFor="
            let product of products
              | paginate: { itemsPerPage: 12, currentPage: page };
            trackBy: productService.trackByProductID
          "
          fxFlex="25"
          fxFlex.lt-md="50"
        >
          <app-product-card [product]="product"></app-product-card>
        </div>
      </div>
    </ng-container>
    <ng-template #notFound>
      <h2>Aucun Résultat</h2>
    </ng-template>
  </ng-container>
</div>
